<template>
  <div class="Home">
    <div class="titlePage">{{this.$route.params.Area}}</div>
    <ShortPresen :InfoView="this.links"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ShortPresen from '@/components/dashboard/Shortcuts.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'Home',
  components: { ShortPresen },
  data () {
    return {
      links: [],
    }
  },
  methods: {
    callLoadMenu () {
      var linksData = IberoHelpers.getItemsMenu(
        this.$store,
        this.$session.get('IberoJWTAdminLogin').idPerson,
        this.$route.params.Area
      )
      linksData.then(Response => {
        console.log(Response.data)
        if (Response.data) {
          this.links = Response.data
        } else {
          this.links = []
        }
        IberoHelpers.forceRerender1(this)
      })
    },
  },
  created: function () {
    if (this.$session.get('IberoJWTAdminLogin').idPerson !== undefined) {
      this.callLoadMenu()
    } else {
      this.$session.remove('IberoJWTAdminLogin')
      this.$router.push({ name: 'not-found-simple' })
    }
  },
  computed: {
    ...mapState(['OperatorPresen']),
  },
}
</script>

<style lang="scss"></style>
